import {get} from "./base";

const Users = {
    index: () => get("/users"),
};

export default Users;